// extracted by mini-css-extract-plugin
module.exports = {"root":"az__kb","disabled":"az_alb","labelPlacementStart":"az_blb","labelPlacementTop":"az_clb","labelPlacementBottom":"az_dlb","label":"az_elb"};